import React from 'react'
import { Link } from 'react-router-dom'

export default function breadcrumb() {
  return (
    <nav className="breadcrumb">
      <Link to="/">Home</Link> <i className="fas fa-angle-right"></i>{" "}
      <Link to="/me/profile">Profile</Link>
    </nav>
  );
}
